import { MediaModel } from "@src/utils/components/dropzone";
import { now, toApiDate } from "@src/utils/dates";
import { required } from "@src/utils/forms/validators";
import { FieldState, FormState } from "formstate";
import { compact } from "lodash";

export class Form {
  brand_id = new FieldState("").validators(required);
  purchase_order_no = new FieldState("").validators(required);
  date_of_order = new FieldState<Date | undefined>(now()).validators();
  files = new FieldState<MediaModel[]>([]).validators();
  project_ids = new FieldState<string[]>([]);

  _form = new FormState({
    brand_id: this.brand_id,
    purchase_order_no: this.purchase_order_no,
    date_of_order: this.date_of_order,
    files: this.files,
    project_ids: this.project_ids,
  });

  addFiles(files: File[]) {
    this.files.onChange([
      ...this.files.value,
      ...files.map((i) => new MediaModel(i)),
    ]);
  }

  removeFile(file: MediaModel) {
    this.files.onChange(this.files.value.filter((i) => i !== file));
  }

  async validate() {
    return await this._form.validate();
  }

  serialize() {
    return {
      brand_id: this.brand_id.$,
      purchase_order_no: this.purchase_order_no.$,
      date_of_order: this.date_of_order.$ && toApiDate(this.date_of_order.$),
      files: compact(this.files.$.map((f) => f.isFile && f._file)),
      project_ids: this.project_ids.$,
    };
  }

  reset() {
    this._form.reset();
  }
}
